export const style = {
  container: {
    padding: "1.2rem 0.8rem",
    borderBottom: "0.1rem solid var(--gray-20)",
    background: "var(--neutral-100)",
    cursor: "pointer",
  },
  appointmentDate: {
    color: "var(--black-900)",
    textOverflow: "ellipsis",
    fontSize: "1.4rem",
    fontWeight: 500,
  },
  totalBookedContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  slotContainer: {
    marginLeft: "0.4rem",
    padding: "0.4rem 0.8rem",
    borderRadius: "1.5rem",
    background: "var(--gray-20)",
    "& > p": {
      color: "var(--gray-400)",
      fontSize: "1.2rem",
      fontWeight: 400,
    },
  },
  totalBooked: {
    color: "var(--gray-400)",
    fontSize: "1.2rem",
    fontWeight: 400,
  },
  appointmentTime: {
    color: "var(--gray-400)",
    fontSize: "1.2rem",
    fontWeight: 400,
  },
};
